import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { Box } from '@mui/material';
import CustomFieldsSection from 'app/shared/components/customFields/CustomFieldsSection';
import { CUSTOM_FIELDS_TARGET } from 'app/shared/components/customFields/CustomFieldsSection/CustomFieldsSection.constants';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { selectPropertyAndLoanSummarySubjectPropertyData } from 'store/loanApplications/selectors/propertyAndLoan.selectors';

const PropertyCustomFields = ({ className, customFieldsController }) => {
  const { applicationId } = useParams();
  const subjectPropertyData = useSelector(selectPropertyAndLoanSummarySubjectPropertyData);
  const propertyId = subjectPropertyData?.propertyId ?? null;

  if (_.isNil(propertyId)) {
    return null;
  }

  return (
    <Box className={className}>
      <CustomFieldsSection
        applicationId={applicationId}
        controller={customFieldsController}
        target={CUSTOM_FIELDS_TARGET.PROPERTY}
        targetEntityId={propertyId}
      />
    </Box>
  );
};

PropertyCustomFields.propTypes = {
  customFieldsController: PropTypes.shape({
    definitions: PropTypes.array.isRequired,
    formValues: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    setFieldValue: PropTypes.func.isRequired,
  }).isRequired,
  className: PropTypes.string,
};

export default memo(PropertyCustomFields);
